import {useLocation, useParams} from "react-router-dom";
import {useEffect} from "react";
import {routerStore} from "@services/routerObserver/router.store";

export const RouterObserver = () => {
    const location = useLocation();
    const params = useParams();

    useEffect(() => {
        routerStore.update(location, params);
    }, [location, params]);

    return null;
};